import LightModeRoundedIcon from "@mui/icons-material/LightModeRounded";
import DarkModeRoundedIcon from "@mui/icons-material/DarkModeRounded";
import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Badge from "@mui/material/Badge";
import Tooltip from "@mui/material/Tooltip";
import Link from "@mui/material/Link";
import { useAuth } from "../../../Helpers/Contexts/AuthContext";
import { useAppContext } from "../../../Helpers/Contexts/AppContext";
import NavUser from "../NavUser";
import "./NavBar.css";

// Nav Bar
export default function NavBar({ darkMode, setDarkMode }) {
    // App Context
    const [, setAppContext] = useAppContext();
    const { isDemo } = useAuth();

    // Drawer
    function toggleDrawer() {
        setAppContext((prev) => ({ ...prev, drawerOpened: !prev.drawerOpened }));
    }

    // Alterna entre Claro e Azul Profundo
    function toggleTheme() {
        setDarkMode((prev) => {
            const next = !prev;
            localStorage.setItem('app-darkMode', next ? 'true' : 'false');
            return next;
        });
    }

    // Component
    return (<AppBar position="static" sx={{ backgroundColor: "transparent", backgroundImage: "none", boxShadow: "none", borderBottom: '1px solid', borderColor: 'divider' }}>
        <Toolbar
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                paddingY: 0,
                position: "relative",
            }}
        >
            {/* Modo demo: convite fixo no centro da barra (mesmo link do botão "Ajuda") */}
            {isDemo && (
                <Link
                    href="https://wa.me/"
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="hover"
                    sx={{
                        position: "absolute", left: "50%", transform: "translateX(-50%)",
                        display: { xs: "none", md: "block" }, whiteSpace: "nowrap",
                        fontSize: 14, fontWeight: 600, color: "warning.main",
                    }}
                >
                    Entre em contato para cadastrar sua empresa
                </Link>
            )}
            {/* Menu Icon & Breadcrumbs */}
            <Box
                sx={{display: "flex", alignItems: "center", height: "100%"}}
                justifyContent="left"
            >
                <IconButton
                    onClick={toggleDrawer}
                    color="inherit"
                    size="small"
                    sx={{
                        width: 36,
                        height: 36,
                        mr: 1,
                        color: 'text.secondary',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                            color: 'text.primary',
                        }
                    }}
                    aria-label="Alternar barra lateral"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect width="18" height="18" x="3" y="3" rx="2"></rect>
                        <path d="M9 3v18"></path>
                    </svg>
                </IconButton>
            </Box>
            
            {/* Right: Dark mode toggle & Notifications */}
            <Box sx={{display: "flex", alignItems: "center", gap: 1}} justifyContent="right">
                {/* Dark mode toggle (Claro / Azul Profundo) */}
                <Tooltip title={darkMode ? "Mudar para Modo Claro" : "Mudar para Modo Escuro (Azul Profundo)"} arrow>
                    <IconButton
                        onClick={toggleTheme}
                        color="inherit"
                        size="small"
                        sx={{
                            width: 36,
                            height: 36,
                            color: darkMode ? '#3b82f6' : 'text.secondary',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                                color: 'text.primary',
                            }
                        }}
                        aria-label="Alternar tema (Claro / Azul Profundo)"
                    >
                        {darkMode
                            ? <LightModeRoundedIcon sx={{ fontSize: 20 }} />
                            : <DarkModeRoundedIcon sx={{ fontSize: 20 }} />
                        }
                    </IconButton>
                </Tooltip>
                

                {/* Notification Bell */}
                <IconButton
                    color="inherit"
                    size="small"
                    sx={{
                        width: 36,
                        height: 36,
                        color: 'text.secondary',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                            color: 'text.primary',
                        }
                    }}
                    aria-label="Notificações"
                >
                    <Badge color="error" variant="dot">
                        <NotificationsRoundedIcon sx={{ fontSize: 20 }} />
                    </Badge>
                </IconButton>

                {/* User Profile Card */}
                <NavUser compact={true} />
            </Box>
        </Toolbar>
    </AppBar>);
}
